import styled from 'styled-components';

// @source
import { theme } from '../../styles';

export const UploadFile = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border: 1px dashed ${theme.border};
  border-radius: 2px;
  margin-top: 1.5rem;
`;

export const FileDragArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  vertical-align: middle;
  padding: 1rem;
  background-color: ${theme.background};

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
    cursor: pointer;
  }
`;

export const UploadFileIcon = styled.div`
  margin: 0 auto;
  text-align: center;
`;
